import React, { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { changePasswordSchema } from "../../schema";
import { changePassApi } from "../../api";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import "primereact/resources/primereact.min.css";
import { Toast } from "primereact/toast";

const initialValues = {
  oldpassword: "",
  newpassword: "",
  confirmpassword: "",
};

export const ChangePassword = () => {
  const navigate = useNavigate();
  const toast = useRef(null);

  const handleChangePass = async (values, action) => {
    changePassApi(values)
    .then ((response) => {
      toast.current.show({severity: 'success', summary: `${response?.data?.message}`});
      action.resetForm()
      navigate("/user-management");
    })
    .catch((err)=> {
      toast.current.show({severity: 'error', summary: `${err?.response?.data?.message}`});
    })
  }; 

  const { values, errors, handleChange, handleSubmit, touched, handleBlur } =
    useFormik({
      initialValues,
      validationSchema: changePasswordSchema,
      onSubmit: (values, action) => handleChangePass(values, action),
    });

  return (
    <>
      <div className="all-login-signup-forgot-pass-model">
        <Toast ref={toast} />
        <div className="loop-text-cls-add">
          <h1>The Loop</h1>
        </div>
        <div class="auth_screen">
          <div class="row">
            <div class="col-lg-12">
              <div class="auth_box">
                <div class="auth_body mt-4 w-100">
                  <h6 class="mb-4">Change password</h6>
                  <form onSubmit={handleSubmit} class="">
                    <div class="form-content">
                      <div class="form-group">
                        <label class="form-label all-label-same">
                          Old Password
                        </label>
                        <input
                          type="password"
                          name="oldpassword"
                          formcontrolname="oldpassword"
                          maxLength="50"
                          class="form-control input-underline input-lg"
                          placeholder="Old Password"
                          value={values.oldpassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.oldpassword && touched.oldpassword ? (
                          <p className="form-error">{errors.oldpassword}</p>
                        ) : null}
                      </div>
                      <div class="form-group mb-2 mt-4">
                        <div class="d-flex justify-content-between">
                          <label class="form-label all-label-same">
                            New Password
                          </label>
                        </div>
                        <input
                          type="password"
                          name="newpassword"
                          formcontrolname="newpassword"
                          maxLength="30"
                          class="form-control input-underline input-lg "
                          placeholder="New Password"
                          value={values.newpassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.newpassword && touched.newpassword ? (
                          <p className="form-error">{errors.newpassword}</p>
                        ) : null}
                      </div>
                      <div class="form-group mb-2 mt-4">
                        <div class="d-flex justify-content-between">
                          <label class="form-label all-label-same">
                            Confirm Password
                          </label>
                        </div>
                        <input
                          type="password"
                          name="confirmpassword"
                          formcontrolname="confirmpassword"
                          maxLength="30"
                          class="form-control input-underline input-lg "
                          placeholder="Confirm Password"
                          value={values.confirmpassword}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {errors.confirmpassword && touched.confirmpassword ? (
                          <p className="form-error">{errors.confirmpassword}</p>
                        ) : null}
                      </div>
                      <div class="mt-2 text-end">
                        <div class="row mt-4 mb-2">
                          <div class="col-lg-12">
                            <button
                              type="submit"
                              class="btn fill_btn same-all-btn-primary"
                              onChange={handleChange}
                            >
                              Change
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
